var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLayout',[_c('Fleet',{attrs:{"pageTitle":_vm.$t('components.fleetManagement.headline')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }